// Internet je Router (internal/wan, Endpoint /v2-api/wan/summary): oben
// der Anschluss hinter forge (TCP-Probe zu 1.1.1.1:443 plus die Werte
// seines Agenten), unter `routers` jeder Router einzeln. Form und reine
// Rechnungen: lib/netzwerk/netz.ts.
//
// Dünne Sicht auf den gemeinsamen Stand in rechner.svelte.ts: seit 03.11.2026
// kommt das Summary über das Homelab-Protokoll (wan.lage; docs/protokoll.md ›
// „WAN und Rechner über das Protokoll“) -- immer das VOLLE Summary aller Router,
// darum springt nichts, wenn zwei Router abwechselnd senden --, REST nur beim
// Start im gemeinsamen Stand. Kein eigener Takt; der WS-Kanal "wan" ist seit
// 03.11.2026 abgebaut.
//
// SWR: ja -- das Summary kommt beim Start aus der Ablage von rechner.svelte.ts.

import { getWanAusRechner, startRechner } from "./rechner.svelte";
import type { WanStatus } from "./netzwerk/netz";

export type { WanRouter, WanStatus } from "./netzwerk/netz";

let _off: (() => void) | undefined;

export function startWan(): void {
  if (_off) return;
  _off = startRechner();
}

export function stopWan(): void {
  _off?.();
  _off = undefined;
}

export function getWan(): WanStatus | undefined {
  return getWanAusRechner();
}
